<script>
import { mapState } from "vuex";

export default {
  name: "CertDocs",

  computed: {
    ...mapState({
      certificatePurchase: (state) =>
        state.tariffDocs.documents.certificatePurchase,
    }),
  },
};
</script>

<template>
  <div class="cert-docs" v-html="certificatePurchase" />
</template>

<style lang="scss" scoped>
.cert-docs {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &:deep(h4) {
    color: var(--text-dark-primary, #212121);

    @include body-1-bold;
  }

  &:deep(p) {
    color: var(--text-dark-primary, #212121);

    @include body-1;
  }

  &:deep(ul) {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > li {
      color: var(--text-dark-primary, #212121);

      @include body-1;
    }
  }
}
</style>
